if (!customElements.get('variant-selects-custom')) {
  customElements.define(
    'variant-selects-custom',
    class VariantSelectsCustom extends HTMLElement {
      connectedCallback() {
        if (!this.closest('variant-selects')) return;

        this.onDocumentClick = null;

        this.initCustomSelects();
        this.addEventListeners();
      }

      initCustomSelects() {
        const selectWrapperElems = this.querySelectorAll('.js-wrapper');
        selectWrapperElems.forEach((wrapperEl) => this.initCustomSelect(wrapperEl));
      }

      addEventListeners() {
        this.onDocumentClick = (e) => this.closeAllDropdowns(e);
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        if (this.onDocumentClick) document.removeEventListener('click', this.onDocumentClick);
      }

      initCustomSelect(wrapperEl) {
        const field = this.getFieldElements(wrapperEl);
        if (!field) return;

        const { selectEl, triggerEl, listEl, optionElems } = field;
        const sync = () => this.syncField(selectEl, triggerEl, listEl, optionElems);

        triggerEl.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleDropdown(listEl, triggerEl);
        });

        optionElems.forEach((optionEl) => {
          optionEl.addEventListener('click', () => {
            this.selectOption(selectEl, triggerEl, listEl, optionEl.dataset.value);
            sync();
          });
        });

        selectEl.addEventListener('change', sync);
        sync();
      }

      getFieldElements(wrapperEl) {
        const selectEl = wrapperEl.querySelector('.js-select');
        const triggerEl = wrapperEl.querySelector('.js-trigger');
        const listEl = wrapperEl.querySelector('.js-list');
        const optionElems = wrapperEl.querySelectorAll('.js-option');

        if (!selectEl || !triggerEl || !listEl) return null;

        return { selectEl, triggerEl, listEl, optionElems };
      }

      syncField(selectEl, triggerEl, listEl, optionElems) {
        const selectedOption = selectEl.options[selectEl.selectedIndex];
        const selectedText = selectedOption ? selectedOption.textContent.trim() : '';

        // const labelEl = triggerEl.querySelector('.js-trigger-label');
        // if (labelEl) {
        //   labelEl.textContent = selectedText;
        // } else {
        //   triggerEl.textContent = selectedText;
        // }
        
        // triggerEl.setAttribute('aria-expanded', listEl.hidden ? 'false' : 'true');

        // optionElems.forEach((optionEl) => {
        //   const selected = optionEl.dataset.value === selectEl.value;

        //   optionEl.setAttribute('aria-selected', selected ? 'true' : 'false');
        //   optionEl.classList.toggle('variant-selects-custom__option--selected', selected);
        // });
      }

      toggleDropdown(listEl, triggerEl) {
        const wasClosed = listEl.hidden;

        if (wasClosed) {
          this.closeOtherDropdowns(listEl, triggerEl);
        }

        listEl.hidden = !wasClosed;
        triggerEl.setAttribute('aria-expanded', wasClosed ? 'true' : 'false');
      }

      closeOtherDropdowns(exceptListEl, exceptTriggerEl) {
        this.querySelectorAll('.js-list').forEach((el) => { if (el !== exceptListEl) el.hidden = true; });
        this.querySelectorAll('.js-trigger').forEach((el) => { if (el !== exceptTriggerEl) el.setAttribute('aria-expanded', 'false'); });
      }

      selectOption(selectEl, triggerEl, listEl, value) {
        selectEl.value = value;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        listEl.hidden = true;
        triggerEl.setAttribute('aria-expanded', 'false');
      }

      closeAllDropdowns(e) {
        if (this.contains(e.target)) return;
        
        this.querySelectorAll('.js-list').forEach((el) => { el.hidden = true; });
        this.querySelectorAll('.js-trigger').forEach((el) => el.setAttribute('aria-expanded', 'false'));
      }
    }
  );
}
